import { z } from "zod";
import { personCommonSchema } from "@/types/schemas/person";
import { CompanyTypeValues, CustomerTypeValues } from "@/constants/customer";
import { dateSchema } from "./date";
import { isArray } from "remeda";
import { addressWithTypeSchema } from "./address";

export const contactSchema = z.object({
  email: z.preprocess(name => (name === null ? "" : name), z.string()),
  emailEbill: z.nullable(z.string()),
  mobilePhone: z.preprocess(name => (name === null ? "" : name), z.string()),
  mobileCountryCode: z.string().optional(),
  phone: z.string().nullable(),
  emailPrimkon: z.boolean().nullable().default(null),
  mobilePrimkon: z.boolean().nullable().default(null),
});

const customerCommonSchema = personCommonSchema.merge(
  z.object({
    contact: contactSchema,
    customerId: z.number().or(z.string()).nullable().optional(),
    deathDateCore: dateSchema,
    classification: z.unknown().nullable(),
    titleLet: z.unknown().nullable(),
    invPostal: z.boolean().optional(),
    payer: z.boolean().optional(),
    receiver: z.boolean().optional(),
    ebillEdit: z.boolean().optional(),
    taxPayer: z.boolean().default(false),
    deathDate: dateSchema,
    specificDepositType: z.string().nullable(),
  })
);

export const companyDetailsSchema = z.object({
  cznace: z.nullable(z.unknown()),
  caseReferenceInsert: z.preprocess(name => (name === null ? "" : name), z.string()),
  caseReferencePlace: z.preprocess(name => (name === null ? "" : name), z.string()),
  caseReferenceSection: z.preprocess(name => (name === null ? "" : name), z.string()),
  fromAres: z.boolean(),
  orgId: z.preprocess(name => (name === null ? "" : name), z.string()),
  vatId: z.preprocess(name => (name === null ? "" : name), z.string()),
  personalNumber: z.nullable(z.string()),
  taxPayer: z.boolean().default(false),
});

export const customerSchema = customerCommonSchema.extend({
  customerType: z.nativeEnum(CustomerTypeValues),
  companyType: z.nativeEnum(CompanyTypeValues).nullable(),
  company: z.string().nullable(),
  companyDetails: companyDetailsSchema,
});

export const previousCustomerSchema = z.object({
  name: z.preprocess(name => (name === null ? "" : name), z.string()),
  surname: z.preprocess(name => (name === null ? "" : name), z.string()),
  degreeAfterId: z.preprocess(name => (name === null ? "" : name), z.string()),
  degreeBeforeId: z.preprocess(name => (name === null ? "" : name), z.string()),
  degreeBeforeId2: z.preprocess(name => (name === null ? "" : name), z.string()),
  birthDate: dateSchema,
  customerType: z.nativeEnum(CustomerTypeValues).nullable(),
  companyType: z.nativeEnum(CompanyTypeValues).nullable(),
  company: z.string().nullable(),
  companyDetails: z.object({
    vatId: z.preprocess(name => (name === null ? "" : name), z.string()),
    orgId: z.preprocess(name => (name === null ? "" : name), z.string()),
    personalNumber: z.nullable(z.string()),
  }),
  contact: z.object({
    email: z.preprocess(name => (name === null ? "" : name), z.string()),
    mobilePhone: z.preprocess(name => (name === null ? "" : name), z.string()),
    mobileCountryCode: z.string().optional(),
  }),
  addresses: z.preprocess(addr => (isArray(addr) && addr.length === 0 ? [] : addr), z.array(addressWithTypeSchema)),
});
